/** 个股筛选输入框宽度（px） */
export const MY_NOTES_STOCK_FILTER_WIDTH = 200;

/** 笔记列表每页条数 */
export const MY_NOTES_PAGE_SIZE = 10;

/** 「共X条」左侧内边距（px），与筛选按钮文字左对齐 */
export const MY_NOTES_COUNT_PADDING_LEFT = 10;

/** 空状态文案距上方区域的上边距（px） */
export const MY_NOTES_EMPTY_MARGIN_TOP = 108;

/** 笔记列表为空时的引导文案 */
export const MY_NOTES_EMPTY_MOTTO =
  "好记性不如烂笔头，养成记笔记的习惯，方便自我复盘，快速洞察适合自己的投资方法。";

/** 空状态「立即写笔记」文字按钮颜色 */
export const MY_NOTES_EMPTY_COMPOSE_COLOR = "#ff85c0";

/** 「笔记统计」文字按钮颜色 */
export const MY_NOTES_STATS_BTN_COLOR = " #1e56ef";

/** 「笔记统计」文字按钮 hover 颜色 */
export const MY_NOTES_STATS_BTN_HOVER_COLOR = "rgba(0, 0, 0, 0.75)";

/** 「笔记统计」与「记笔记」按钮间距（px） */
export const MY_NOTES_STATS_BTN_COMPOSE_GAP = 20;

/** 个股筛选输入框距左侧筛选项间距（px） */
export const MY_NOTES_STOCK_FILTER_MARGIN_LEFT = 12;

/** 统计弹框宽度（px） */
export const MY_NOTES_STATS_MODAL_WIDTH = 440;

/** 统计弹框内容区圆角（px） */
export const MY_NOTES_STATS_MODAL_BORDER_RADIUS = 8;

/** 统计弹框内容区背景色 */
export const MY_NOTES_STATS_MODAL_BACKGROUND = "#ffffff";

/** 统计弹框内边距（px） */
export const MY_NOTES_STATS_MODAL_PADDING = "20px 24px 16px";

/** 有效率主卡片背景色 */
export const MY_NOTES_STATS_HERO_BACKGROUND = "#f0f7eb";

/** 有效率主卡片圆角（px） */
export const MY_NOTES_STATS_HERO_BORDER_RADIUS = 8;

/** 有效率标题区内边距（px） */
export const MY_NOTES_STATS_HERO_HEAD_PADDING = "12px 20px 0px";

/** 有效率数值区内边距（px） */
export const MY_NOTES_STATS_HERO_BODY_PADDING = "8px 20px 24px";

/** 有效率标签字号（px） */
export const MY_NOTES_STATS_HERO_LABEL_FONT_SIZE = 14;

/** 有效率数值字号（px） */
export const MY_NOTES_STATS_HERO_VALUE_FONT_SIZE = 40;

/** 笔记有效率数值颜色（强调） */
export const MY_NOTES_STATS_RATE_VALUE_COLOR = "#389e0d";

/** 次要统计项卡片背景色 */
export const MY_NOTES_STATS_ITEM_BACKGROUND = "#f4f5f9";

/** 次要统计项卡片圆角（px） */
export const MY_NOTES_STATS_ITEM_BORDER_RADIUS = 6;

/** 次要统计项卡片内边距（px） */
export const MY_NOTES_STATS_ITEM_PADDING = "12px 10px";

/** 次要统计项标签文字颜色 */
export const MY_NOTES_STATS_LABEL_COLOR = "rgba(0, 0, 0, 0.55)";

/** 次要统计项标签字号（px） */
export const MY_NOTES_STATS_LABEL_FONT_SIZE = 12;

/** 次要统计项数值文字颜色 */
export const MY_NOTES_STATS_VALUE_COLOR = "rgba(0, 0, 0, 0.88)";

/** 次要统计项数值字号（px） */
export const MY_NOTES_STATS_VALUE_FONT_SIZE = 20;

/** 次要统计项 flex 占比：总笔记数（其余三项各为 1） */
export const MY_NOTES_STATS_TOTAL_FLEX = 1.5;
